module.exports = __webpack_public_path__ + "img/39.800ab6d9.png";